import "./HeaderRenderer.css";

import { Column } from "react-data-grid";
import type { HeaderRendererProps } from "react-data-grid";

import { PropertySet } from "../../model/core/Workbook";
import { columnBeingEditedAtom } from "./PropertyDescriptorAtoms";
import { useSetAtom } from "jotai";
import { TableSortLabel } from "@mui/material";

const headerCellClassname = "headerCellCss";

export function headerRenderer(columnId: number, properties: PropertySet) {
  return <R, SR>({
    column,
    sortDirection,
    priority,
    onSort,
    isCellSelected,
  }: HeaderRendererProps<R, SR>) => {
    if (!column.sortable) {
      return (
        <StaticHeaderCell
          column={column}
          columnId={columnId}
          properties={properties}
        >
          {column.name}
        </StaticHeaderCell>
      );
    }

    return (
      <SortableHeaderCell
        onSort={onSort}
        sortDirection={sortDirection}
        priority={priority}
        isCellSelected={isCellSelected}
      >
        <StaticHeaderCell
          column={column}
          columnId={columnId}
          properties={properties}
        >
          {column.name}
        </StaticHeaderCell>
      </SortableHeaderCell>
    );
  };
}

type SharedHeaderCellProps<R, SR> = Pick<
  HeaderRendererProps<R, SR>,
  "sortDirection" | "onSort" | "priority" | "isCellSelected"
>;

interface SortableHeaderCellProps<R, SR> extends SharedHeaderCellProps<R, SR> {
  children: React.ReactNode;
}

interface StaticHeaderCellProps<R, SR> {
  column: Column<R, SR>;
  columnId: number;
  properties: PropertySet;
  children: React.ReactNode;
}

function StaticHeaderCell<R, SR>({
  column,
  columnId,
  properties,
  children,
}: StaticHeaderCellProps<R, SR>) {
  const setColumnBeingEdited = useSetAtom(columnBeingEditedAtom);

  function handleClick(event: React.MouseEvent<HTMLSpanElement>) {
    setColumnBeingEdited({
      columnId: columnId,
      columnName: column.name as string,
    });
  }
  return (
    <>
      <span
        className={headerCellClassname}
        onClick={handleClick}
        // eslint-disable-next-line jsx-a11y/aria-role
        role="columnedit"
      >
        <span>{children}</span>
      </span>
    </>
  );
}

function SortableHeaderCell<R, SR>({
  onSort,
  sortDirection,
  priority,
  children,
  isCellSelected,
}: SortableHeaderCellProps<R, SR>) {
  function handleKeyDown(event: React.KeyboardEvent<HTMLSpanElement>) {
    if (event.key === " " || event.key === "Enter") {
      // stop propagation to prevent scrolling
      event.preventDefault();
      onSort(event.ctrlKey || event.metaKey);
    }
  }

  function handleClick(event: React.MouseEvent<HTMLSpanElement>) {
    onSort(event.ctrlKey || event.metaKey);
  }

  if (sortDirection) {
    console.log(sortDirection);
  }

  return (
    <span>
      {children}
      <TableSortLabel
        active={!!sortDirection}
        direction={sortDirection === "ASC" ? "asc" : "desc"}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      ></TableSortLabel>
    </span>
  );
}
